import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import {Row, Col, Spinner,Form, Button, Modal } from "react-bootstrap";
import FieldDateTime from '../common/FieldDateTime';
import FieldSelect from '../common/FieldSelect';
import FieldMultiSelect from '../common/FieldMultiSelect';
import FieldMultiMainModel from '../common/FieldMultiMainModel';
import FieldSearchSelect from '../common/FieldSearchSelect';
import Util from '../../util/Util';
import Const from '../../util/Constants';
import MeetingAPI from '../../api/MeetingAPI';
import ValidationController from '../../controller/ValidationController';
import FieldTextArea from '../common/FieldTextArea';
import ApiUiController from '../../controller/ApiUiController';
import MeetingCustom from './MeetingCustom';
import Display from "../../util/Display";
class MeetingPopup extends React.Component {

  constructor(props) {
    super(props);
    this.model = reactLocalStorage.getObject(Const.Model).meeting;
    const MulUser = `~${parseInt(reactLocalStorage.getObject(Const.LoggedInUser).user_id)}~`;

    this.meeting = {
      id: 0, date_time: Util.dateToServerDateTime(new Date()), project: 0, feedback: 0,
      comment: '', responsible_person: MulUser, complete: 0, end_call: '',
      next_call: '', next_meet: '', model_no: props.model_no, model_id: props.model_id
    };

    this.showPropertyMeeting = this.model.fields.property && this.model.fields.property.visible === Const.True;

    this.state = {
      inValid: {},
      inApiCall: false,
      meeting: { ...this.meeting },
      isSubmitClick: false,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.model_id !== this.state.model_id || props.model_no !== this.state.model_no) {
      this.meeting = { ...this.meeting, model_no: props.model_no, model_id: props.model_id };
    }
    if (props.meeting && props.meeting.id !== this.state.meeting.id) {
      this.setState({ ...this.state, meeting: { ...props.meeting } });
    } else if (!props.meeting) {
      this.setState({ ...this.state, meeting: { ...this.meeting } });
    }
  }

  onChange = (field, value) => {
    const meeting = { ...this.state.meeting };
    meeting[field] = value;
    this.setState({ ...this.state, meeting: { ...meeting } });
  };

  onSave = () => {
    const inValid = ValidationController.validate(this.model.fields, this.state.meeting);
    if (inValid === null) {
      MeetingAPI.save(this.state.meeting, this.onSaved, this.onFail);
      this.setState({ ...this.state, inApiCall: true });
    } else { this.setState({ ...this.state, inValid: { ...inValid } }); }
  };
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };
  onSaved = res => {
    Util.showNotification('Successful', 'Site Visit saved successfully', 'success');
    this.setState({ ...this.state, meeting: { ...this.state.meeting, id: res.id }, inApiCall: false });
    this.setState({ ...this.state, inApiCall: false });
    this.props.onHide();
    if (this.props.reload) this.props.reload();
  };

  handleClick = async () => {
    this.state.isSubmitClick = true;
    await this.onSave();
    setTimeout(() => (this.state.isSubmitClick = false), 1000);
  };

  render() {
    const fields = this.model.fields;
    const inValid = this.state.inValid;
    let meeting = this.state.meeting;
    const showNext = meeting.feedback !== 0;

    return (
 <Modal
        {...this.props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onExit={() => (this.isAPICalled = false)}
        className="meeting-popup-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {this.props?.meeting ? "Update" : "Add"} {this.model.model_name} :{" "}
            {Display.ModelName(this.props.lead || this.props.contact)}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <ApiUiController inApiCall={this.state.inApiCall}>
              <Row className="g-3">
                {fields.date_time ? (
                  <Col md={6}>
                    <FieldDateTime
                      key="date_time"
                      id="date_time"
                      field={fields.date_time}
                      value={meeting.date_time}
                      onValueChange={this.onChange}
                      inValid={inValid}
                    />
                  </Col>
                ) : null}

                {fields.property && fields.property.visible ? (
                  <Col md={6}>
                    <FieldSearchSelect
                      key="property"
                      id="property"
                      field={fields.property}
                      value={meeting.property}
                      onValueChange={this.onChange}
                      inValid={inValid}
                      project={0}
                    />
                  </Col>
                ) : null}

                {fields.project && fields.project.visible ? (
                  <Col md={6}>
                    <FieldSelect
                      key="project"
                      id="project"
                      field={fields.project}
                      value={meeting.project}
                      onValueChange={this.onChange}
                      inValid={inValid}
                    />
                  </Col>
                ) : null}

                     {this.props.contacts ? (
            
                  <Col md={6}>
                    <FieldMultiMainModel
                      key="contacts"
                      id="contacts"
                      field={fields.contacts}
                      value={meeting.contacts}
                      options={this.props.contacts}
                      onValueChange={this.onChange}
                      inValid={inValid}
                    />
                  </Col>
               
              ) : null}
              </Row>

         

              <Row className="g-3 mt-2">
                {fields.responsible_person ? (
                  <Col md={6}>
                    <FieldMultiSelect
                      key="responsible_person"
                      id="responsible_person"
                      field={fields.responsible_person}
                      value={meeting.responsible_person}
                      onValueChange={this.onChange}
                      inValid={inValid}
                    />
                  </Col>
                ) : null}

                {fields.feedback ? (
                  <Col md={6}>
                    <FieldSelect
                      key="feedback"
                      id="feedback"
                      field={fields.feedback}
                      value={meeting.feedback}
                      onValueChange={this.onChange}
                      inValid={inValid}
                    />
                  </Col>
                ) : null}
              </Row>

              {fields.comment ? (
                <Row className="g-3 mt-2">
                  <Col md={12}>
                    <FieldTextArea
                      key="comment"
                      id="comment"
                      field={fields.comment}
                      value={meeting.comment}
                      onValueChange={this.onChange}
                      inValid={inValid}
                    />
                  </Col>
                </Row>
              ) : null}

              <Row className="g-3 mt-2">
                <Col md={6}>
                  <MeetingCustom
                    model={this.model}
                    meeting={meeting}
                    onValueChange={this.onChange}
                    inValid={this.state.inValid}
                  />
                </Col>
              </Row>
              {showNext ? (
               <Row className="g-3 mt-2">
                {fields.next_call && fields.next_call.visible ? (
                  <Col md={6}>
                    <FieldDateTime
                      key="next_call"
                      id="next_call"
                      field={fields.next_call}
                      value={meeting.next_call}
                      onValueChange={this.onChange}
                      inValid={inValid}
                    />
                  </Col>
                ) : null}

                {fields.next_meet && fields.next_meet.visible ? (
                  <Col md={6}>
                    <FieldDateTime
                      key="next_meet"
                      id="next_meet"
                      field={fields.next_meet}
                      value={meeting.next_meet}
                      onValueChange={this.onChange}
                      inValid={inValid}
                    />
                  </Col>
                ) : null}
              </Row>
              ) : null}
            </ApiUiController>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          {!this.state.isSubmitClick ? (
            <Button onClick={this.handleClick} disabled={this.state.inApiCall}>
              Submit
            </Button>
          ) : null}
        </Modal.Footer>
      </Modal>
    );
  }
}
export default MeetingPopup;